import React from 'react';
import { useTrilogyContext } from "../../context";
import { hashClass } from "../../helpers";
import clsx from "clsx";
import { is } from "../../services";
import { ScrollDirectionEnum } from "../../objects";
/**
 * Scroll View Component
 * @param children {React.ReactNode} ScrollView child
 * @param id {string} Id for Web / TestID for Native
 * @param scrollDirection {Direction} Scroll vertically or horizontally
 * - -------------- WEB PROPERTIES ---------------
 * @param className {string} Additionnal css classes
 * - -------------- NATIVE PROPERTIES ---------------
 * @param footer {React.ReactNode} ScrollView footer
 * @param bounce {boolean} Bounce effect on scroll
 * @param centerContent {boolean} center content in scrollView
 * @param refresh {boolean} Is Refreshable ScrollView
 * @param onRefresh {void} On Refreshing ScrollView
 */
const ScrollView = React.forwardRef(({ id, scrollDirection, children }, ref) => {
    const { styled } = useTrilogyContext();
    const scrollDirectionClassName = () => {
        switch (scrollDirection) {
            case ScrollDirectionEnum === null || ScrollDirectionEnum === void 0 ? void 0 : ScrollDirectionEnum.HORIZONTAL:
                return is('horizontal');
            case ScrollDirectionEnum === null || ScrollDirectionEnum === void 0 ? void 0 : ScrollDirectionEnum.VERTICAL:
                return is('vertical');
            default:
                return '';
        }
    };
    const classes = hashClass(styled, clsx('scroll-view', scrollDirection && scrollDirectionClassName()));
    return React.createElement("div", { ref: ref, className: classes, id: id }, children);
});
ScrollView.displayName = 'ScrollView';
export default ScrollView;
//# sourceMappingURL=ScrollView.js.map